export const buttonBase =
  'inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-evault-teal/35 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';

export const buttonVariants = {
  primary:
    'bg-evault-teal text-white shadow-sm shadow-evault-teal/20 hover:bg-evault-teal-hover active:bg-evault-teal-active',
  secondary:
    'border border-evault-teal/35 bg-white text-evault-teal hover:bg-evault-select-bg active:bg-evault-select-ring/40',
  /* Originator redesign variants (additive) */
  navy: 'bg-eorig-navy-600 text-white shadow-sm shadow-eorig-navy/20 hover:bg-eorig-navy-700 active:bg-eorig-navy',
  gradient:
    'bg-eorig-gradient text-white shadow-sm shadow-eorig-cyan/25 hover:opacity-95 active:opacity-90',
  ghost:
    'border border-eorig-border bg-white text-eorig-ink hover:bg-eorig-surface active:bg-eorig-border/60',
};

/** Small "Beta" pill used beside titles in the Originator redesign. */
export function BetaTag({ className = '' }) {
  return (
    <span
      className={`inline-flex items-center rounded-full bg-eorig-gradient px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white ${className}`.trim()}
    >
      Beta
    </span>
  );
}

export function Button({
  variant = 'primary',
  className = '',
  type = 'button',
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={`${buttonBase} ${buttonVariants[variant] ?? buttonVariants.primary} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
